import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '@shared/services';

@Component({
  selector: 'lib-two-factor-onetime-modal',
  templateUrl: 'two-factor-onetime-modal.component.html',
})
export class TwoFactorOnetimeModalComponent {
  private readonly router = inject(Router);
  private readonly modalService = inject(ModalService);

  public setupNow() {
    this.modalService.dismiss();
    this.router.navigate(['/managetwofactorauthentication']);
  }

  public onClose() {
    this.modalService.dismiss();
  }
}
